import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ComponentBase } from '../../../../../core/_infrastructure/classes/componentBase';
import { UntypedFormBuilder } from '@angular/forms';
import { Table } from 'primeng/table';
import { TPartidaPreduaViewModel, PartidaPreduaItemResultViewModel } from '../../../predua/predua.types';
import { PreduaService } from '../../../predua/predua.service';
import { Dialog } from 'primeng/dialog';

@Component({
    selector: 'app-partida-predua-popup',
    templateUrl: './partidaPreduaPopup.component.html',
})
export class PartidaPreduaPopupComponent extends ComponentBase implements OnInit {
    @Output() selected = new EventEmitter<TPartidaPreduaViewModel>();

    @ViewChild('tableSearch') turboTable: Table;
    resultPartidaPredua: PartidaPreduaItemResultViewModel;
    display = false;
    cols: any[];
    selectedPartidaPredua: TPartidaPreduaViewModel | null;

    public isCollapsed = false;

    constructor(
        private fb: UntypedFormBuilder,
        private preduaService: PreduaService,
    ) {
        super();
    }

    ngOnInit() {
        this.cols = [
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Partida', header: 'Partida' },
            { field: 'CodigoTaric', header: 'Código Taric' },
            { field: 'PaisOrigen', header: 'País Origen' },
            { field: 'IdPaisOrigen', header: 'IdPaisOrigen', display: 'none' },
            { field: 'PesoNeto', header: 'Peso Neto (kg)' },
        ];

        this.form = this.fb.group({
            Partida: '',
            CodigoTaric: '',
            PaisOrigen: '',
            IdPaisOrigen: '',
            PesoNeto: '',
        });

        this.resultPartidaPredua = new PartidaPreduaItemResultViewModel();
    }

    showDialog(partidas: TPartidaPreduaViewModel[]): void {
        this.display = true;
        this.selectedPartidaPredua = null;
        this.resultPartidaPredua.ResultList = partidas;
    }

    onRowDblClick(event: any, partidaPredua: TPartidaPreduaViewModel): void {
        this.display = false;

        this.selected.emit(partidaPredua);
    }

    acceptDialog(): void {
        this.display = false;

        this.selected.emit(this.selectedPartidaPredua!);
    }

    cancelDialog(): void {
        this.display = false;
    }

    showDialogMaximized(dialog: Dialog): void {
        setTimeout(() => {
            dialog.maximize();
        }, 0);
    }

    onSelect(selection: TPartidaPreduaViewModel): void {
        this.selectedPartidaPredua = selection;
    }

    noAccepted(): boolean {
        return !this.selectedPartidaPredua;
    }
}
